import { DocumentNode, gql } from '@apollo/client'

export const USE_STAFF_AUTO_LINK: DocumentNode = gql`
    mutation UseStaffAutoLink($autoLink: String!) {
        useStaffAutoLink(auto_link: $autoLink)
    }
`

export const RESET_STAFF_AUTO_LINK: DocumentNode = gql`
    mutation ResetStaffAutoLink($daycareId: Int!) {
        resetStaffAutoLink(daycareId: $daycareId)
    }
`

export const ACTIVE_STAFF_AUTO_LINK: DocumentNode = gql`
    mutation ActiveStaffAutoLink($daycareId: Int!) {
        activeStaffAutoLink(daycareId: $daycareId)
    }
`

export const DEACTIVE_STAFF_AUTO_LINK: DocumentNode = gql`
    mutation DeactiveStaffAutoLink($daycareId: Int!) {
        deactiveStaffAutoLink(daycareId: $daycareId)
    }
`

export const GET_STAFF_AUTO_LINK_MAIL: DocumentNode = gql`
    mutation GetStaffAutoLinkMail($daycareId: Int!) {
        getStaffAutoLinkMail(daycare_id: $daycareId)
    }
`
